"use strict";

class StationSettingsApiRestTokenCtrl {
    constructor($rootScope, $scope, $state) {

        let parentCtrl = $scope.$parent.ctrl;
        this.genToken = null;
        this.currentToken = null;

        //Wait until info is loaded
        const unregisterTokenGetter = $scope.$watch(() => {
            return parentCtrl.tokens[$state.params.tokenId];
        }, (currentToken) => {

            this.genToken = {};
            this.currentToken = currentToken;

            if (!this.currentToken) {
                return;
            }

            angular.extend(this.genToken, this.currentToken);

            this.genToken.permissions = {};

            this.currentToken.permissions.forEach((permission) => {
                this.genToken.permissions[permission.id] = true;
            });

            parentCtrl.genToken = this.genToken;
        });

        const unregisterSettingsGetter = $scope.$watch(() => {
            if ($scope.restsettings !== undefined) {
                return $scope.restsettings.$invalid;
            }
        }, (newVal) => {
            $rootScope.saveDisabled = newVal;
        });

        $scope.$on('$destroy', () => {
            unregisterTokenGetter();
            unregisterSettingsGetter();
        });

    }
}


StationSettingsApiRestTokenCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$state'
];

module.exports = StationSettingsApiRestTokenCtrl;